export enum DocumentCategoryEnum {
  ID_USER = "ID_USER",
  ID_OWNER = "ID_OWNER",
  ID_SPOUSE = "ID_SPOUSE",
  SELFIE_OWNER = "SELFIE_OWNER",
  DEATH_CERTIFICATE = "DEATH_CERTIFICATE",
  INVENTORY = "INVENTORY",
  DILIGENCE = "DILIGENCE",
  LAWYER_ATTACHMENT = "LAWYER_ATTACHMENT",
  OFFICER_ACCEPTENCE_CONTRACT = "OFFICER_ACCEPTENCE_CONTRACT",
  OFFICER_CESSION_CONTRACT = "OFFICER_CESSION_CONTRACT",
  ADMIN_CESSION_CONTRACT = "ADMIN_CESSION_CONTRACT",
  OFFICER_INVOICE = "OFFICER_INVOICE",
  MARRIAGE_CERTIFICATE = "MARRIAGE_CERTIFICATE",
  LETTER_OF_ATTORNEY = "LETTER_OF_ATTORNEY",
  TED_RECEIPT = "TED_RECEIPT",
  RESIDENTIAL_CERTIFICATE = "RESIDENTIAL_CERTIFICATE",
  PUBLIC_DEED = "PUBLIC_DEED",
  LEGAL_PROCESS = "LEGAL_PROCESS",
  COMPLIANCE = "COMPLIANCE",
  TICKET = "TICKET",
  PROOF_OF_RESIDENCE = "PROOF_OF_RESIDENCE",
  CLICK_SIGN_CONTRACT_ACCEPTENCE_TERM = "CLICK_SIGN_CONTRACT_ACCEPTENCE_TERM",
  CLICK_SIGN_CONTRACT_CESSION_TERM = "CLICK_SIGN_CONTRACT_CESSION_TERM",
  CLICK_SIGN_CONTRACT_OLD_CESSION_TERM = "CLICK_SIGN_CONTRACT_OLD_CESSION_TERM",
  ADMIN_ACCEPTENCE_CONTRACT = "ADMIN_ACCEPTENCE_CONTRACT",
  SPECIAL_PROJECT_DOCUMENT = "SPECIAL_PROJECT_DOCUMENT",
  GENERAL_CONDITIONS_TERM = "GENERAL_CONDITIONS_TERM",
  SUBSTABELECIMENTO = "SUBSTABELECIMENTO",
  OTHERS = "OTHERS",
  MARRIAGE_PRENUPTIAL_AGREEMENT = "MARRIAGE_PRENUPTIAL_AGREEMENT",
  DIGITAL_CERTIFICATE = "DIGITAL_CERTIFICATE",


  FINANCIAL_DEPOSITADO = "FINANCIAL_DEPOSITADO",
  FINANCIAL_PENDENTE = "FINANCIAL_PENDENTE",
  FINANCIAL_TRANSFERENCIA_APROVADA = "FINANCIAL_TRANSFERENCIA_APROVADA",
  FINANCIAL_PAGO = "FINANCIAL_PAGO",

  LEGAL_PROTOCOLADO = "LEGAL_PROTOCOLADO",
  LEGAL_NAO_PROTOCOLADO = "LEGAL_NAO_PROTOCOLADO",
  LEGAL_CESSAO_INDEFERIDO = "LEGAL_CESSAO_INDEFERIDO",
  LEGAL_RECURSO_INTERPOSTO = "LEGAL_RECURSO_INTERPOSTO",
  LEGAL_HOMOLOGADO = "LEGAL_HOMOLOGADO",
  LEGAL_COM_ALVARA = "LEGAL_COM_ALVARA",

  EXPEDITION_TYPE_PRE_PRECATORIO = "EXPEDITION_TYPE_PRE_PRECATORIO",
  EXPEDITION_TYPE_PRECATORIO_EXPEDIDO = "EXPEDITION_TYPE_PRECATORIO_EXPEDIDO",
  EXPEDITION_TYPE_LOA_REGISTRATION = "EXPEDITION_TYPE_LOA_REGISTRATION",

  PROCURACAO_AD_JUDICIA_PRIVADA = "PROCURACAO_AD_JUDICIA_PRIVADA",
  PROCURACAO_AD_JUDICIA_PUBLICA = "PROCURACAO_AD_JUDICIA_PUBLICA",

  CERTIFICATE_DISTRIBUTION = "CERTIFICATE_DISTRIBUTION",
  CERTIFICATE_OF_WORK_IN_PROCESSING = "CERTIFICATE_OF_WORK_IN_PROCESSING",
  CERTIFICATE_ELECTRONIC_OF_LABOR_ACTIONS = "CERTIFICATE_ELECTRONIC_OF_LABOR_ACTIONS",
  CERTIFICATE_OF_DISTRIBUTION_OF_ACTIONS_CRIMINAIS_ON_LINE = "CERTIFICATE_OF_DISTRIBUTION_OF_ACTIONS_CRIMINAIS_ON_LINE",
  CERTIFICATE_PROCESSES_DISTRIBUTED_TRF = "CERTIFICATE_PROCESSES_DISTRIBUTED_TRF",
  CERTIFICATE_PGNF_ECAC = "CERTIFICATE_PGNF_ECAC",
  CONTRACT_HONORARIOS = "CONTRACT_HONORARIOS",
  PRIVATE_DEED = "PRIVATE_DEED"
  
}

export const DocumentCategoryLabel = new Map<DocumentCategoryEnum, string>([
  [DocumentCategoryEnum.ID_USER, "ID Usuário"],
  [DocumentCategoryEnum.ID_OWNER, "Identidade do Cliente"],
  [DocumentCategoryEnum.ID_SPOUSE, "Identidade do Conjuge"],
  [DocumentCategoryEnum.SELFIE_OWNER, "Selfie Cliente"],
  [DocumentCategoryEnum.DEATH_CERTIFICATE, "Certidão de Óbito"],
  [DocumentCategoryEnum.INVENTORY, "Inventário"],
  [DocumentCategoryEnum.DILIGENCE, "Diligência"],
  [DocumentCategoryEnum.LAWYER_ATTACHMENT, "Anexo de Advogado"],
  [DocumentCategoryEnum.OFFICER_ACCEPTENCE_CONTRACT, "Termo de Aceite via Officer"],
  [DocumentCategoryEnum.OFFICER_CESSION_CONTRACT, "Termo de Cessão via Officer"],
  [DocumentCategoryEnum.ADMIN_CESSION_CONTRACT, "Termo de Cessão via Admin"],
  [DocumentCategoryEnum.OFFICER_INVOICE, "Invoice"],
  [DocumentCategoryEnum.MARRIAGE_CERTIFICATE, "Certidão de Casamento"],
  [DocumentCategoryEnum.LETTER_OF_ATTORNEY, "Procuração"],
  [DocumentCategoryEnum.TED_RECEIPT, "Recibo TED"],
  [DocumentCategoryEnum.RESIDENTIAL_CERTIFICATE, "Certidão de Residência"],
  [DocumentCategoryEnum.PUBLIC_DEED, "Escritura Publica"],
  [DocumentCategoryEnum.LEGAL_PROCESS, "Processo Legal"],
  [DocumentCategoryEnum.COMPLIANCE, "Compliante"],
  [DocumentCategoryEnum.TICKET, "Ticket"],
  [DocumentCategoryEnum.PROOF_OF_RESIDENCE, "Comprovante de Endereço"],
  [DocumentCategoryEnum.CLICK_SIGN_CONTRACT_ACCEPTENCE_TERM, "Termo de Aceite (Click Sign)"],
  [DocumentCategoryEnum.CLICK_SIGN_CONTRACT_CESSION_TERM, "Antigo Termo de Cessão (Click Sign)"],
  [DocumentCategoryEnum.CLICK_SIGN_CONTRACT_OLD_CESSION_TERM, "Novo Termo de Cessão (Click Sign)"],
  [DocumentCategoryEnum.ADMIN_ACCEPTENCE_CONTRACT, "Contrato de Aceite via Admin"],
  [DocumentCategoryEnum.MARRIAGE_PRENUPTIAL_AGREEMENT, "Pacto Antenupcial"],
  [DocumentCategoryEnum.FINANCIAL_DEPOSITADO, "Evidencia Status Financeiro Depositado"],
  [DocumentCategoryEnum.FINANCIAL_PENDENTE, "Evidencia Status Financeiro Pendente"],
  [DocumentCategoryEnum.FINANCIAL_TRANSFERENCIA_APROVADA, "Evidencia Status Financeiro Transferência aprovada"],
  [DocumentCategoryEnum.FINANCIAL_PAGO, "Andamento do processo ou extrato do depósito"],
  [DocumentCategoryEnum.LEGAL_PROTOCOLADO, "Evidencia Status Jurídico Protocolado"],
  [DocumentCategoryEnum.LEGAL_NAO_PROTOCOLADO, "Evidencia Status Jurídico Não protocolado"],
  [DocumentCategoryEnum.LEGAL_HOMOLOGADO, "Andamento do processo ou despacho"],
  [DocumentCategoryEnum.LEGAL_CESSAO_INDEFERIDO, "Evidencia Status Jurídico Cessão indeferida"],
  [DocumentCategoryEnum.LEGAL_RECURSO_INTERPOSTO, "Evidencia Status Jurídico Recurso interposto"],
  [DocumentCategoryEnum.LEGAL_COM_ALVARA, "Evidencia Status Jurídico Com alvará"],
  [DocumentCategoryEnum.EXPEDITION_TYPE_PRE_PRECATORIO, "Evidencia Pré precatório"],
  [DocumentCategoryEnum.EXPEDITION_TYPE_PRECATORIO_EXPEDIDO, "Ofício"],
  [DocumentCategoryEnum.EXPEDITION_TYPE_LOA_REGISTRATION, "Andamento do processo ou Printscreen da LOA"],
  [DocumentCategoryEnum.PROCURACAO_AD_JUDICIA_PRIVADA, "Procuração AD Judicia Privada"],
  [DocumentCategoryEnum.PROCURACAO_AD_JUDICIA_PUBLICA, "Procuração AD Judicia Publica"],
  [DocumentCategoryEnum.CERTIFICATE_DISTRIBUTION, "Certidão de Distribuição"],
  [DocumentCategoryEnum.CERTIFICATE_OF_WORK_IN_PROCESSING, "Certidão de ação trabalhista em tramitação"],
  [DocumentCategoryEnum.CERTIFICATE_ELECTRONIC_OF_LABOR_ACTIONS, "Certidão eletrônica de ações trabalhista"],
  [DocumentCategoryEnum.CERTIFICATE_OF_DISTRIBUTION_OF_ACTIONS_CRIMINAIS_ON_LINE, "Certidão de Distribuição de ações criminais Online"],
  [DocumentCategoryEnum.CERTIFICATE_PROCESSES_DISTRIBUTED_TRF, "Certidão processos distribuídos TRF"],
  [DocumentCategoryEnum.CERTIFICATE_PGNF_ECAC, "Certidão PGNF/E-CAC"],
  [DocumentCategoryEnum.CONTRACT_HONORARIOS, "Contratos de honorários"],
  [DocumentCategoryEnum.DIGITAL_CERTIFICATE, "Certificado Digital"],
  [DocumentCategoryEnum.PRIVATE_DEED, "Instrumento de cessao particular"]

]);



// WEBPACK FOOTER //
// ./src/components/Refatoracao/UploadDocument/DocumentCategoryEnum.ts